module.exports = __webpack_public_path__ + "static/media/select.487a6db1.svg";